module.exports = __webpack_public_path__ + "static/media/dianchi.bf2df70.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp3/dianchi.mp3
// module id = jKlK
// module chunks = 208